<div *ngIf="visibleCookies === false" id="cookiesBox" [ngClass]="{'cart': isCart}" class="{{showLang}}">
    <div class="cookieWrapper">
        <div *ngIf="lotteryService.isMobile" class="cookieIco"><img [src]="'/assets/images/icons/icon/cookies_ico.png'"></div>
        <div class="cookieText">
            <span id="basicCookies" class="">
                <div>{{'cookies.weUse' | translate}}
                <span class="expandInfo" (click)="expandInfo()">Cookies.</span>
                </div>
                <!--<div *ngIf="!lotteryService.isMobile">{{'cookies.01' | translate}}-->
                <!--<span class="expandInfo" (click)="expandInfo()">{{'cookies.02' |translate}}</span>-->
                <!--</div>-->
            </span>
            <span id="moreCookies" class="hide">{{'cookies.03' |translate}}</span>
        </div>
        <div class="cookieClose" (click)="acceptCookies()"><img [src]="'/assets/images/navigation/close_cookies.png'" /> </div>
    </div>
</div>

